/* assets/cc-card-add.js */
(() => {
  async function addToCart(variantId, qty = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty })
    });
    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      throw new Error('Add failed: ' + txt);
    }
    return res.json();
  }

  async function updateCartSections() {
    // Ask Shopify to render the cart drawer + bubble HTML
    const url = `/?sections=cart-drawer,cart-icon-bubble`;
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return;

    const html = await res.json();

    // Update cart icon bubble
    if (html['cart-icon-bubble']) {
      const bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html['cart-icon-bubble'];
        const newBubble = tmp.firstElementChild;
        if (newBubble) bubble.replaceWith(newBubble);
      }
    }

    // Update cart drawer
    if (html['cart-drawer']) {
      const existing = document.querySelector('cart-drawer');
      if (existing) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html['cart-drawer'];
        const newDrawer = tmp.querySelector('cart-drawer') || tmp.firstElementChild;
        if (newDrawer) {
          existing.replaceWith(newDrawer);
          // open the new drawer (Dawn exposes .open())
          setTimeout(() => document.querySelector('cart-drawer')?.open?.(), 0);
        }
      }
    }
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-cc-add');
    if (!btn) return;

    // prevent the product link under it from being triggered
    e.preventDefault();
    e.stopPropagation();

    const id = btn.dataset.variantId;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      await addToCart(id, 1);
      btn.textContent = 'Added ✓';
      await updateCartSections();
    } catch (err) {
      console.error(err);
      btn.textContent = 'Error — view';
      // fall back to product page if anything goes wrong
      setTimeout(() => (window.location.href = btn.dataset.productUrl || '/cart'), 700);
    } finally {
      setTimeout(() => { btn.disabled = false; btn.textContent = original; }, 1200);
    }
  }, true);
})();
    